import { render } from "./MerchantDetails.vue?vue&type=template&id=d5b64ccc&scoped=true"
import script from "./MerchantDetails.vue?vue&type=script&lang=js"
export * from "./MerchantDetails.vue?vue&type=script&lang=js"

import "./MerchantDetails.vue?vue&type=style&index=0&id=d5b64ccc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5b64ccc"]])

export default __exports__